export enum ProductOfferingCode {
    CA7_A = 'CA7_A',
    CA7_B3 = 'CA7_B3',
    CA7_B1 = 'CA7_B1',
    CA7_B = 'CA7_B',
    CA7_C4 = 'CA7_C4',
    CA7_C1 = 'CA7_C1',
    CA7_C = 'CA7_C',
    CA7_CPlus = 'CA7_CPlus',
    CA7_CM = 'CA7_CM',
    CA7_D = 'CA7_D'
}

export enum ProductOfferingName {
    CA7_A = 'A',
    CA7_B3 = 'B3',
    CA7_B1 = 'B1',
    CA7_B = 'B',
    CA7_C4 = 'C4',
    CA7_C1 = 'C1',
    CA7_C = 'C',
    CA7_CPlus = 'C+',
    CA7_CM = 'CM',
    CA7_D = 'D'
}
